/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/terms-of-service/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { renderTermsOfServiceContent } from 'BomdisoftComponents/terms-of-service/render';

type TermsOfServiceProps = {
  companyName: string;
  supportEmail: string;
  className?: string;
};

export const TermsOfService = ({ companyName, supportEmail, className }: TermsOfServiceProps) => <article className={joinClasses('bomdisoft-terms-of-service', className)} dangerouslySetInnerHTML={{ __html: renderTermsOfServiceContent({ companyName, supportEmail }).value }} />;
